const steps = [
  'Sobre o Dispositivo',
  'Entrega e Coleta',
  'Sobre Você',
  'Ordem de Serviço',
];

export default steps;
